import React, { Component } from "react";
import ExercisesTrainingService from '../../../../../services/exercises/training/ExercisesTrainingService';
import { withTranslation } from "react-i18next";

type Props = {
    exerciseId: string;
    trainingId: number;
    onExerciseUpdate: () => void; // Funkcja do odświeżenia listy
    t: any;
};

class OptionsCopy extends Component<Props> {
    handleCopy = async () => {
        const { exerciseId, trainingId, onExerciseUpdate, t } = this.props;
        try {
            await ExercisesTrainingService.copyExercise(trainingId, exerciseId);
            onExerciseUpdate(); // Aktualizacja listy po skopiowaniu
        } catch (error) {
            console.error('Error copying exercise:', error);
        }
    };

    render() {
        const { t } = this.props;
        return (
            <div className="center">
                <button onClick={this.handleCopy}>
                    {/* {t("buttons.repeat")} */}
                    {t("buttons.copy")}
                </button>
                {/* <p>{t("buttons.repeat_description")}<br/><br/></p> */}
                <br /><br />
            </div>
        );
    }
}

export default withTranslation("global")(OptionsCopy);
